"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const nodeListToArray_1 = require("../general/nodeListToArray");
exports.elToHtmlString = (el) => {
    if (!el) {
        return '';
    }
    if (el.nodeType === el.DOCUMENT_NODE &&
        el.ownerDocument &&
        el.ownerDocument.documentElement) {
        return el.ownerDocument.documentElement.outerHTML;
    }
    if (typeof Document !== 'undefined' &&
        el instanceof Document &&
        el.documentElement) {
        return el.documentElement.outerHTML;
    }
    if (el.nodeName.toLowerCase() === 'template' && lodash_1.get(el, 'innerHTML')) {
        return el.innerHTML;
    }
    if (el.nodeType === el.DOCUMENT_FRAGMENT_NODE) {
        return [...nodeListToArray_1.nodeListToArray(el.childNodes)]
            .map(n => (n.nodeType === 3 ? n.textContent : n.outerHTML))
            .join('');
    }
    // Hack for JSDom
    if (lodash_1.get(el, 'location')) {
        if (el && el.ownerDocument && el.ownerDocument.documentElement) {
            return el.ownerDocument.documentElement.outerHTML;
        }
    }
    return lodash_1.get(el, 'outerHTML') || '';
};
//# sourceMappingURL=elToHtmlString.js.map